import { z } from '@harvestiq/zod';

export const sendWelcomeEmailRequestBodySchema = z.object({
  userIds: z.array(z.string().uuid()).min(1),
});
export type SendWelcomeEmailRequestBody = z.infer<
  typeof sendWelcomeEmailRequestBodySchema
>;

export const sendWelcomeEmailResponseSchema = z
  .object({
    sentCount: z.number(),
    skippedCount: z.number(),
  })
  .or(
    z.object({
      errors: z.string().array(),
    })
  );
export type SendWelcomeEmailResponse = z.infer<
  typeof sendWelcomeEmailResponseSchema
>;
